import styled from 'styled-components';
export const Container = styled.div `
    display: flex;
    width: 100%;
    flex-direction: row;
    margin-top: 16px;
    box-sizing: border-box;
    align-items: center;
    cursor: pointer;

    &:last-of-type {
        margin-bottom: 16px;
    }
`;
//# sourceMappingURL=index.js.map